import React from 'react';
import './subscriptionConstraintForm.css';
import { useDispatch, useSelector } from "react-redux";
import { subscriptionConstraintFormAction,
    typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updateSubscriptionConstraintSagaAction } from "../../redux/sagaActions";

// Название дней недели
const dayNames = {
    mon: 'Понедельник',
    tue: 'Вторник',
    wed: 'Среда',
    thu: 'Четверг',
    fri: 'Пятница',
    sat: 'Суббота',
    sun: 'Воскресенье',
};

const SubscriptionConstraintForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const subscription_constraint_form = useSelector(state => state.subscription_constraint_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(typeOpenSettingsFormAction('')) }/>
                        <div className="form__title">Ограничение</div>
                    </div>
                    <div className="constraint">
                        <div className="form__field">
                            <div className="input__caption input__caption--required">Название ограничения</div>
                            <input type="text" className="input" value={ subscription_constraint_form.name }
                                   onInput={ event => dispatch(subscriptionConstraintFormAction({
                                       ...subscription_constraint_form,
                                       name: event.target.value
                                   })) }
                            />
                        </div>
                        <div className="input__caption" style={{ marginLeft: '12px', marginBottom: '-2px' }}>Укажите время, в которое абонемент будет действовать</div>
                        {
                            // Перебираем все дни расписания по ключам
                            Object.keys(subscription_constraint_form.schedule).map(day => {
                                return (
                                    <div className="constraint__day" key={ day }>
                                        <div
                                            className="constraint__time-add"
                                            onClick={ () => {
                                                // Копируем расписание
                                                let scheduleCopy = JSON.parse(JSON.stringify(subscription_constraint_form.schedule));
                                                // Добавляем новый временной интервал
                                                scheduleCopy[day].push({ from: '', to: '' });
                                                // Сохраняем обновлённое расписание
                                                dispatch(subscriptionConstraintFormAction({
                                                    ...subscription_constraint_form,
                                                    schedule: scheduleCopy
                                                }))
                                            } }
                                        >Добавить интервал</div>
                                        <div className="constraint__day-name">{ dayNames[day] }</div>
                                        {
                                            subscription_constraint_form.schedule[day].map((time, index) => {
                                                return (
                                                    <div className="constraint__time" key={ index }>
                                                        <input type="time" className="input constraint__value"
                                                               value={ subscription_constraint_form.schedule[day][index].from }
                                                               onInput={ event => {
                                                                   // Копируем расписание
                                                                   let scheduleCopy = JSON.parse(JSON.stringify(subscription_constraint_form.schedule));
                                                                   // Меняем значение времени
                                                                   scheduleCopy[day][index].from = event.target.value;
                                                                   // Сохраняем значение времени в нужном интервале
                                                                   dispatch(subscriptionConstraintFormAction({
                                                                       ...subscription_constraint_form,
                                                                       schedule: scheduleCopy
                                                                   }))
                                                               } }
                                                        />
                                                        <div className="constraint__delimiter">−</div>
                                                        <input type="time" className="input constraint__value"
                                                               value={ subscription_constraint_form.schedule[day][index].to }
                                                               onInput={ event => {
                                                                   // Копируем расписание
                                                                   let scheduleCopy = JSON.parse(JSON.stringify(subscription_constraint_form.schedule));
                                                                   // Меняем значение времени
                                                                   scheduleCopy[day][index].to = event.target.value;
                                                                   // Сохраняем значение времени в нужном интервале
                                                                   dispatch(subscriptionConstraintFormAction({
                                                                       ...subscription_constraint_form,
                                                                       schedule: scheduleCopy
                                                                   }))
                                                               } }
                                                        />
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...subscription_constraint_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(subscriptionConstraintFormAction({
                                                ...subscription_constraint_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ subscription_constraint_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(updateSubscriptionConstraintSagaAction({
                                     id: subscription_constraint_form.id,
                                     name: subscription_constraint_form.name,
                                     establishments: JSON.stringify(subscription_constraint_form.establishments),
                                     schedule: JSON.stringify(subscription_constraint_form.schedule)
                                 }));
                             } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionConstraintForm;